<template>
  <el-option :label="item.label" :value="item.value" :disabled="item.disabled"></el-option>
</template>

<script>
/* eslint-disable semi */
import { Component, Prop } from 'vue-property-decorator';
import SasComponent from './SasComponent';

/**
 * 基本的な選択要素コンポーネント
 */
@Component
export default class SasSelectOption extends SasComponent {
  @Prop({ type: Object })
  item;
}
</script>



// WEBPACK FOOTER //
// src/core/ui/SasSelectOption.vue